export class TypeFormation {
    constructor(
        public id?: number,
        public idTypeFormation?: number,
        public code?: string,
        public libelle?: string,
        public habilitation?: number,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/type-formation.model.ts